module.exports = __webpack_public_path__ + "static/media/logo-sbs.a4a6e356.png";